module.exports = __webpack_public_path__ + "static/img/value02.4fb7861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/value02.png
// module id = brAC
// module chunks = 0